export default function () {
    const switchOff = document.querySelectorAll('.js-switch-off');
    const switchOn = document.querySelectorAll('.js-switch-on');
    const switchBtn = document.querySelectorAll('.c-switch-btn__checkbox');
    if(switchBtn) {
        switchOn.forEach(function(item) {
            item.addEventListener('click', function(){
                changeOn(this);
            });
        });
        switchOff.forEach(function(item) {
            item.addEventListener('click', function(){
                changeOff(this);
            });
        });
        switchBtn.forEach(function(item) {
            item.addEventListener('click', function(){
                if (this.checked) {
                    changeOn(this);
                } else {
                    changeOff(this);
                }
            });
        });
    }

    function changeOn(t) {
        t.parentNode.querySelector('.js-switch-on').classList.add('is-active');
        t.parentNode.querySelector('.js-switch-off').classList.remove('is-active');
        t.parentNode.querySelector('.c-switch-btn__checkbox').checked = true;
    }
    function changeOff(t) {
        t.parentNode.querySelector('.js-switch-off').classList.add('is-active');
        t.parentNode.querySelector('.js-switch-on').classList.remove('is-active');
        t.parentNode.querySelector('.c-switch-btn__checkbox').checked = false;
    }

    /*const switchOff = document.querySelector('.js-switch-off');
    const switchOn = document.querySelector('.js-switch-on');
    const switchBtn = document.querySelector('#switch-btn');
    var trigger = document.querySelectorAll(".trigger");

    function changeOff() {
        switchOff.classList.add('is-active');
        switchOn.classList.remove('is-active');
    }

    function changeOn() {
        switchOn.classList.add('is-active');
        switchOff.classList.remove('is-active');
    }

    
    if(switchBtn) {
        switchOff.addEventListener('click', function(){
            changeOff();
            switchBtn.checked = false;
        });
        switchOn.addEventListener('click', function(){
            changeOn();
            switchBtn.checked = true;
        });
        switchBtn.addEventListener('click', function(){
            if (this.checked) {
                changeOn();
            } else {
                changeOff();
            }
        });
    }*/
    
}